import { toggleModal } from "components/Stacker/actions/ModalActions"
import { getProductStackList } from "components/Stacker/actions/StackItWithActions"
import classNames from "classnames"
import ModalGeneric from "components/Stacker/components/ModalGeneric/ModalGeneric"
import StackItWithModal from "components/Stacker/components/StackItWithModal/StackItWithModal"
import AmuletItem from "components/Stacker/components/Amulets/AmuletItem/AmuletItem"
import AmuletStackerNecklace from "components/Stacker/components/Amulets/AmuletStackerNecklace/AmuletStackerNecklace"
import ModalConfig from "components/Stacker/config/ModalConfig"
import PropTypes from "prop-types"
import queryString from "query-string"
import React, { useState, useEffect } from "react"
import "./AmuletStackerPromo.scss"
import { getDY_SR } from "stackerConfig"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"

const positions = [
  /* 1 */ [0.5],
  /* 2 */ [0.49, 0.51],
  /* 3 */ [0.46, 0.5, 0.54],
  /* 4 */ [0.47, 0.49, 0.51, 0.53],
  /* 5 */ [0.46, 0.48, 0.5, 0.52, 0.54],
  /* 6 */ [0.45, 0.47, 0.49, 0.51, 0.53, 0.55],
  /* 7 */ [0.44, 0.46, 0.48, 0.5, 0.52, 0.54, 0.56],
]
const vehiclePositions = [
  /* 1 */ [0.5],
  /* 2 */ [0.44, 0.56],
  /* 3 */ [0.35, 0.5, 0.65],
]

function AmuletStackerPromo(props) {
  const [scale, setScale] = useState(1)
  const dispatch = useDispatch()
  const { baseUrl, pdp, stackItWith } = useSelector((state) => {
    return {
      baseUrl: state.application.baseURL,
      pdp: state.pdp,
      stackItWith: state.pdp.stackItWith,
    }
  })

  useEffect(() => {
    const {
      baseStore,
      selectedVariant: { code: productCode },
    } = props
    dispatch(getProductStackList({ productCode, baseStore }))
  }, [])

  const onCustomizeClick = () => {
    const products = stackItWith.stackItBundle[0].stackProducts
    const amulets = products.filter(
      (item) => !Object.keys(item).includes("builderTemplate")
    )
    const necklace = products.filter((item) =>
      Object.keys(item).includes("builderTemplate")
    )[0]
    const queryObj = {
      chainBaseProduct: necklace.baseProductCode,
      chainVariantCode: necklace.productCode,
      products: amulets.map((product) => product.productCode),
    }
    const queryParamsString = queryString.stringify(queryObj, { encode: true })
    const url = `${baseUrl}${
      getDY_SR().config.routing.amuletStacker
    }?${queryParamsString}`
    window.location.href = url
  }

  const onProductResize = (scale) => {
    setScale(scale * 5)
  }

  const handleModalClick = () => {
    dispatch(toggleModal(ModalConfig.MODAL_STACK_IT_WITH, true))
  }

  const createAmulets = (amulets, isVehicle) => {
    const { length } = amulets
    return amulets.map((amulet, i) => {
      const id = amulet.productCode.replace(/ /, "-")
      const to = isVehicle
        ? vehiclePositions[length - 1][i]
        : positions[length - 1][i]
      const src = `${amulet.imageUrl}.jpg`
      return (
        <AmuletItem
          delay={0}
          duration={0}
          id={id}
          isRearrange={false}
          key={id}
          scale={scale}
          src={src}
          to={to}
        />
      )
    })
  }

  const { stackItBundle } = stackItWith
  if (!stackItBundle.length) {
    return null
  }
  const {
    selectedVariant: { code },
  } = props
  const stack = stackItBundle[0].stackProducts
  const amulets = stack.filter(
    (item) => !Object.keys(item).includes("builderTemplate")
  )
  const necklace = stack.filter((item) =>
    Object.keys(item).includes("builderTemplate")
  )[0]

  if (!necklace) {
    return null
  }

  const isVehicle = necklace.builderTemplate === "TEMPLATE_2"
  const stackedAmulets = createAmulets(amulets, isVehicle)
  const classes = classNames(
    "ProductStackItWith AmuletStackerPromo container",
    {
      AmuletStackerPromo__vehicle: isVehicle,
    }
  )

  return (
    <article className={classes}>
      <div className="ProductStackItWith__wrapper">
        <div className="ProductStackItWith__text text-center">
          <h3>Build Your Own Amulet Necklace</h3>
          <p>
            David Yurman amulets are an ode to individuality with charms and
            talismans celebrating the spiritual, natural, global and personal.
          </p>
        </div>
        <div className="ProductStackItWith__stack-container position-relative">
          <div className="AmuletStackerPromo__container absolute-center w-100">
            <AmuletStackerNecklace
              imageUrl={necklace.imageUrl}
              productCode={necklace.productCode}
              onProductResize={onProductResize}
            />
            {isVehicle ? (
              <svg
                viewBox="0 0 770.11401 283.28101"
                className="absolute-center"
              >
                <path
                  d="m 327.64972,143.6323 c 0,0 3.77468,50.96378 55.07682,50.44102 51.30213,-0.52277 52.14024,-50.44102 52.14024,-50.44102"
                  id="path"
                  fill="none"
                  stroke="#000000"
                  strokeOpacity="0"
                  strokeWidth={5}
                  transform=" translate(10) scale(1)"
                />
              </svg>
            ) : (
              <svg
                viewBox="0 0 770.11401 283.28101"
                className="absolute-center"
              >
                <path
                  d="m 165.09053,0.04137568 c 0,0 79.2532,240.68565432 210.22951,249.74378432 C 506.29635,258.84329 586.68265,54.537126 602.80245,0.42410566"
                  id="path"
                  fill="none"
                  stroke="#000000"
                  strokeOpacity="0"
                  strokeWidth={5}
                  transform=" translate(10) scale(1)"
                />
              </svg>
            )}
            <div className="stacked-amulets absolute-center">
              {stackedAmulets}
            </div>
          </div>
          <div className="grandient-overlay absolute-center" />
        </div>
        <div className="ProductStackItWith__btn-container">
          <button
            className="c-btn text-uppercase d-flex align-items-center justify-content-center"
            onClick={onCustomizeClick}
          >
            Customize
          </button>
          <button
            className="c-btn text-uppercase d-flex align-items-center justify-content-center"
            onClick={handleModalClick}
          >
            Shop the set
          </button>
        </div>
      </div>
      <ModalGeneric
        title="Amulet Set"
        name={ModalConfig.MODAL_STACK_IT_WITH}
        standard
      >
        <StackItWithModal productId={code} />
      </ModalGeneric>
    </article>
  )
}

AmuletStackerPromo.propTypes = {
  baseStore: PropTypes.string,
  selectedVariant: PropTypes.object,
}

export default AmuletStackerPromo
